import { Button } from '@ads/components-react';
import { ArrowPathIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

export interface BannerErrorStateProps {
  /** Mensagem do que falhou. */
  readonly message: string;
  /** Refaz a requisição que falhou. */
  readonly onRetry: () => void;
}

/**
 * Estado de erro de carregamento das telas de Banner: diz o que falhou e oferece
 * a nova tentativa.
 *
 * Um componente só para as três telas (listagem, criar e editar) manterem a
 * mesma resposta a falha de rede — antes cada página desenhava a própria caixa.
 */
export function BannerErrorState({ message, onRetry }: BannerErrorStateProps) {
  const { t } = useTranslation('banner');

  return (
    <div
      role="alert"
      className="flex flex-col items-start gap-nano rounded-md border-hairline border-base-danger-300 bg-ctx-layout-surface p-xxs"
    >
      <p className="text-base-danger-700 ts-paragraph-xs">{message}</p>
      <Button hierarchy="secondary" size="md" leadingIcon={ArrowPathIcon} onClick={onRetry}>
        {t('banner.toast.loadErrorRetry')}
      </Button>
    </div>
  );
}
